<template>
    <div class="">
        <div class="container">
            <CommonBreadcrumb class="my-3"/>
        </div>
        <div class="banner">
            <picture>
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/webp"
                    srcset="~/assets/our_care/banner.webp">
                <source media="(min-width: 768px)" width="3840" height="1100" type="image/jpeg"
                    srcset="~/assets/our_care/banner.jpg">

                <source media="(max-width: 991x)" width="750" height="380" type="image/webp"
                    srcset="~/assets/our_care/banner_mob.webp">
                <source media="(max-width: 991px)" width="750" height="380" type="image/jpeg"
                    srcset="~/assets/our_care/banner_mob.jpg">

                <img width="1920" height="550" type="image/jpeg" src="~/assets/our_care/banner.jpg"
                    alt="conflict free diamonds, ethical diamonds">
            </picture>

            <div class="banner_title">

                <h1 class="font-active ">The ‘Friendly’ <span class="small">Share Of Care</span></h1>

                <p class="mb-0">FOR A FRIENDLIER <span>FUTURE</span></p>
            </div>
        </div>

        <div class="container">
            <div class="small_ban share_block">
                <p class="mb-2">
                    An estimated 150 million children worldwide are orphans (UNICEF).
                </p>
                <span>This statistic shook us and we knew we had to be a part of the change.</span>
            </div>

            <div class="row share_block kids_block">
                <div class="col-12 images-container">
                    <picture>
                        <source width="410" height="404" type="image/webp" srcset="~/assets/our_care/boy1.webp">
                        <img class="lazy-image" ref="lazyImage1" width="410" height="404" type="image/jpeg"
                            src="~/assets/our_care/boy1.jpg" alt="child-image">
                    </picture>
                    <picture>
                        <source width="410" height="404" type="image/webp" srcset="~/assets/our_care/girl.webp">
                        <img class="lazy-image" ref="lazyImage2" width="410" height="404" type="image/jpeg"
                            src="~/assets/our_care/girl.jpg" alt="child-image">
                    </picture>
                    <picture>
                        <source width="410" height="404" type="image/webp" srcset="~/assets/our_care/boy2.webp">
                        <img class="lazy-image" ref="lazyImage3" width="820" height="404" type="image/jpeg"
                            src="~/assets/our_care/boy2.jpg" alt="child-image">
                    </picture>
                </div>
            </div>

            <div class="commitment_block share_block text-center">
                <h4 class="font-active mb-3">Our Commitment To Giving Back</h4>
                <p>At Friendly Diamonds, we recognize the importance of giving back to society. We are firm believers in
                    contributing to the betterment of our community, encouraging unity, and paving the way for a brighter
                    future. What truly resonated with us was the staggering statistic that approximately 150 million
                    children are either orphaned or abandoned worldwide.
                    These children face a life of struggle; lacking essential physical, psychological, and sociological
                    support.</p>
                <p>We could not digest that out of these 150 million children, a mere 5% had access to basic education,
                    while many are pushed into a life of disparity. At Friendly Diamonds, we decided to do what we can to
                    help make a change. We have partnered
                    with a non-profit organization to empower individuals and create a <span>friendlier tomorrow.</span>
                </p>
            </div>

            <div class="share_block">
                <div class="video_box">
                    <video @contextmenu.prevent="" controlsList="nodownload" loop controller autoplay playsinline duration muted
                        controls width="1920" height="1080">
                        <source src="https://assets.friendlydiamonds.com/fdl/static-video/orphanage.mp4" type="video/mp4">
                    </video>
                </div>

            </div>

            <div class="row share_block zoom">
                <div class="col-12">
                    <div class="row align-items-center" ref="imageBlocks">
                        <div class="col-12 col-md-6 col-lg-6">
                            <div class="img_block">
                                <picture>
                                    <source width="750" height="380" type="image/webp" srcset="~/assets/our_care/kids.webp">
                                    <img width="625" height="328" type="image/jpeg" src="~/assets/our_care/kids.jpg"
                                        alt="kid">
                                </picture>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6">
                            <div class="text_block">
                                <h4 class="font-active">
                                    Empowering Change
                                </h4>
                                <p>At Friendly Diamonds, we are committed to instigating positive change for underprivileged
                                    children. This inspired us to collaborate with <b><i>Abundant Life Ministry;</i></b> a
                                    non-profit organization transforming the lives of children in need. They provide medical
                                    care, foster homes, education, and quality nutrition to children in need. We work
                                    together to meet the needs of the children in India,
                                    advocate for their education, provide them with safe accommodations, and ensure they
                                    receive the care they deserve.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row flip align-items-center" ref="imageBlocks">
                        <div class="col-12 col-md-6 col-lg-6">
                            <div class="text_block">
                                <h4 class="font-active">
                                    Our Impact So Far
                                </h4>
                                <p>With the help of <b><i>Abundant Life Ministry</i></b>, we were able to identify a group
                                    of 27 orphaned children living a life of disparity in the slums of Mumbai, India. These
                                    children were living in conditions lacking sanitation, hygiene and safety, exposed to
                                    unsafe environments and people.
                                    They were homeschooled by unqualified individuals leaving them with little hope for a
                                    better future. Moved by their unfortunate circumstances, we took action.</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6">
                            <div class="img_block">
                                <picture>
                                    <source width="750" height="380" type="image/webp"
                                        srcset="~/assets/our_care/singlekid.webp">
                                    <img width="625" height="328" type="image/jpeg" src="~/assets/our_care/singlekid.jpg"
                                        alt="kid">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row share_block">
                <h4 class="font-active text-center mb-3">Transformation and Support</h4>
                <div class="col-12 col-lg-4">
                    <div class="accomo_box text-center mb-md-3">
                        <img width="60" height="60" src="~/assets/our_care/accomodation.svg" alt="accomodation">
                        <h4>Accommodation</h4>
                        <p class="para1 mb-2">Lived in slums with inadequate sanitation and safety</p>
                        <P class="para2 mb-0">Moved to safe and comfortable housing with a backyard, privacy, and security
                        </P>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="accomo_box text-center">
                        <img width="60" height="60" src="~/assets/our_care/education.svg" alt="accomodation">
                        <h4>Education</h4>
                        <p class="para1 mb-2">Lack of access to formal education, and were homeschooled by unqualified
                            individuals</p>
                        <P class="para2 mb-0">Enrolled in reputable local convent schools in Mumbai, sponsored by Friendly
                            Diamonds</P>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="accomo_box text-center">
                        <img width="60" height="60" src="~/assets/our_care/sanitation.svg" alt="accomodation">
                        <h4>Sanitation & Support</h4>
                        <p class="para1 mb-2">Limited access to basic facilities and healthcare</p>
                        <P class="para2 mb-0">Provided with essential facilities and ongoing care to support their
                            well-being</P>
                    </div>
                </div>

                <div class="col-12 mt-5 our_group">
                    <picture>
                        <source srcset="~/assets/our_care/group.webp" type="image/webp" width="2500" height="880"
                            alt="group">
                        <source srcset="~/assets/our_care/group.jpg" type="image/jpg" width="2500" height="880" alt="group">
                        <img src="~/assets/our_care/group.jpg" width="2500" height="880" type="image/jpg" alt="group"
                            class="scrollable-image">
                    </picture>
                </div>
            </div>

            <div class="difference share_block text-center">
                <h4>How You Help Us Make a Difference</h4>
                <p class="mb-0">At Friendly Diamonds, every purchase contributes towards this cause. With your support, we
                    aim to expand our impact and reach more children in need. We believe every child deserves a safe and
                    nurturing environment.
                    Embark with us on our journey to empower, uplift and create a <span>friendlier future</span> - one
                    child, one opportunity, and one sparkling destiny at a time.</p>
            </div>
      
            <div class="row share_block">
                <div class="col-12">
                    <div class="end_button">
                        <span>Education isn't just about knowledge; it's a catalyst for transformation.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
useFetchMeta( useNuxtApp(), useRuntimeConfig() );
        const lazyImage1 = ref(null);
        const lazyImage2 = ref(null);
        const lazyImage3 = ref(null);


        const imageBlocks = ref([]);

        function handleIntersect(entries, observer) {
            entries.forEach((entry) => {
                const target = entry.target;
                if (entry.isIntersecting) {
                    target.classList.add('zoom-active');
                    target.classList.remove('zoom-reset');
                    observer.unobserve(target);
                } else {
                    target.classList.add('zoom-reset');
                    target.classList.remove('zoom-active');
                }
            });
        }

        onMounted(() => {
            const lazyImageOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1 
            };

            const lazyImageObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.classList.add('visible');
                        }, index * 200);
                        lazyImageObserver.unobserve(entry.target);
                    }
                });
            }, lazyImageOptions);

            const images = [lazyImage1.value, lazyImage2.value, lazyImage3.value];
            images.forEach((image) => {
                if (image) {
                    lazyImageObserver.observe(image);
                }
            });
            
            imageBlocks.value = document.querySelectorAll('.flip, .zoom');
            const observer = new IntersectionObserver(handleIntersect, {
                threshold: 0.9,
            });

            imageBlocks.value.forEach((block) => {
                observer.observe(block);
            });
        });
</script>

<style scoped>
/* Common */
h4 {
    font-size: 24px;
    color: #353535;
}

p {
    font-size: 16px;
    color: #606060;
}

.commitment_block {
    padding: 0 100px;
}

.commitment_block span {
    color: #668b84;
    font-style: italic;
}

video {
    border-radius: 8px;
    max-width: 100%;
    height: auto;
    clip-path: inset(0);
}
img {
    width: 100%;
    border-radius: 8px;
}

.banner img {
    border-radius: 0;
}

.share_block {
    margin-top: 40px;
    margin-bottom: 40px;
}

.banner {
    position: relative;
}

.banner_title h1 {
    font-size: 60px;
    color: #8d563a;
}

.banner_title .small {
    font-size: 60px;
    color: #d59066;
}

.banner_title p {
    font-size: 24px;
    color: var(--green);
}

.banner_title span {
    color: #d59066;
}

.banner_title span {
    color: #405955;
}

.banner_title {
    position: absolute;
    top: 35%;
    right: 2%;
    transform: translate(-5%, -15%)
}

.small_ban {
    padding: 16px 12px;
    text-align: center;
    background-color: #405955;
    border-radius: 4px;
}

.small_ban p {
    font-size: 18px;
    color: #ffff;
}

.small_ban span {
    font-size: 16px;
    color: #ffff;
    font-style: italic;
}

.images-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
}

.images-container picture {
    width: 32%;
    margin-right: 10px;
}

.images-container picture:last-child {
    margin-right: 0;
}

.images-container img {
    width: 100%;
    height: auto;
}

.accomo_box img {
    width: 60px;
    height: 60px;
}

.accomo_box h4 {
    text-transform: uppercase;
    font-size: 16px;
    color: #353535;
    margin-top: 10px;
}

.accomo_box .para1 {
    font-size: 16px;
    font-weight: 500;
    color: #b18181;
}

.accomo_box .para2 {
    font-weight: 700;
    color: #405955;
}

.difference {
    padding: 0 70px;
}

.difference h4 {
    font-size: 32px;
    margin-bottom: 16px;
}

.end_button {
    background-color: #405955;
    padding: 15px;
    border-radius: 4px;
    text-align: center;
}

.end_button span {
    font-size: 16px;
    font-style: italic;
    color: #ffffff;
}

.lazy-image {
    opacity: 0;
    transition: opacity 0.8s ease-in-out;
}

.lazy-image.visible {
    opacity: 1;
}

@media (max-width: 1600px) {
    .banner_title h1 {
        font-size: 42px;
    }

    .banner_title .small {
        font-size: 42px;

    }
}

@media (max-width: 1150px) {

    .banner_title h1 {
        font-size: 32px;
    }

    .banner_title .small {
        font-size: 32px;

    }
    .images-container picture {
        width: 30%;
    }
}

@media (max-width: 992px) {

    .banner_title {
        position: absolute;
        top: 27%;
        right: 0%;
        transform: translate(-4%, 0%);
    }

    .banner_title h1 {
        font-size: 28px;
    }

    .banner_title .small {
        font-size: 28px;

    }
}

@media (max-width: 767px) {
    p{
        font-size: 14px;
    }
    .our_group {
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scrollable-image {
        width: 100%;
        min-width: 800px;
        height: 300px;
    }
    .banner_title h1 {
        font-size: 28px;
    }

    .banner_title .small {
        font-size: 28px;
    }

    .share_block {
        margin-top: 24px;
        margin-bottom: 24px;
    }

    .small_ban {
        padding: 12px;
    }

    .small_ban p {
        font-size: 16px;
    }

    .small_ban span {
        font-size: 14px;
    }

    .banner_title {
        width: 49%;
        position: absolute;
        top: 40%;
        left: 55%;
        transform: translate(-8%, -20%);
    }

    th,
    td {
        padding: 10px 20px 12px;
        min-width: 300px;
    }

    .banner_title h1 {
        font-size: 24px;
    }

    .banner_title .small {
        font-size: 24px;
    }

    .banner_title p {
        font-size: 15px;
    }

    .img_block {
        margin-bottom: 16px;
    }

    .accomo_box {
        margin: 20px 0;
    }

    .accomo_box .para1 , .para2 {
        font-size: 14px;
        font-weight: 500;
    }
    
    .commitment_block {
        padding: 0 15px;
    }

    .flip {
        flex-direction: column-reverse;
    }

    .difference h4 {
        font-size: 24px;
        margin-bottom: 16px;
    }

    .difference p {
        font-size: 14px;
    }

    .difference {
        padding: 0 15px;
    }

    .difference span {
        font-size: 14px;
    }

    .images-container {
        display: block;
        overflow-y: hidden;
        overflow-x: auto;
        white-space: nowrap;
    }

    .images-container picture {
        display: inline-block;
        width: 100%;
        max-width: 100%;

    }

    .images-container img {
        gap: 10px;
        width: 100%;
        height: auto;
    }
    .end_button span {
        font-size: 14px;
    }
    .zoom-active .img_block,
    .zoom-active .text_block{
        animation: none ;
    }
    .share_block .images-container picture {
        animation: none ;
    }
}

/* 
@keyframes slideInRight {
    0% {
        transform: translateX(-10%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideInLeft {
    0% {
        transform: translateX(15%);
        opacity: 0;
    }

    100% {
        transform: translateX(0);
        opacity: 1;
    }
}

@keyframes slideImageInRight {
    0% {
        transform: translateX(10%) scale(1.03);
        opacity: 0;
    }

    100% {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
}

@keyframes slideImageInLeft {
    0% {
        transform: translateX(-10%) scale(1.03);
        opacity: 0;
    }

    100% {
        transform: translateX(0) scale(1);
        opacity: 1;
    }
}


.zoom-active .img_block {
    animation: zoomInOut 1s ease-in-out, slideImageInRight 1s ease-in-out;
}

.zoom-active .text_block {
    animation: slideInLeft 1s ease-in-out;
}

.zoom-reset .img_block,
.zoom-reset .text_block {
    animation: none;
}


.flip.zoom-active .img_block {
    animation: zoomInOut 1s ease-in-out, slideImageInLeft 1s ease-in-out;
}

.flip.zoom-active .text_block {
    animation: slideInRight 0.8s ease-in-out;
}
*/


</style>